/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Notifications module
 * @module NotificationsModule
 * @preferred
 */

import angular from 'angular';

import {
    syslogController,
} from '.';

const notificationsModule = angular.module('avi/notifications');

const controllers = [
    {
        controller: syslogController,
        name: 'SyslogController',
    },
];

controllers.forEach(({ name, controller }) => notificationsModule.controller(name, controller));
